import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import ContactSubscribedForm from './ContactSubscribedForm'
import uuid from 'uuid/v4'

const stateToProps = ({ form }, otherProps) => ({
  initialValues: {
    triggerId: uuid().slice(0, 6),
    ...otherProps.initialValues,
  },
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(ContactSubscribedForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactSubscribed/ContactSubscribedForm.container.js